module.exports = __webpack_public_path__ + "static/img/user-comment9.54377e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment9.png
// module id = qXxr
// module chunks = 0